<!-- 小程序跳转码 -->
<template>
<div>
	<div id="put-account" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;display: flex;align-items: center;">
		<div class="page-title" style="margin-right: 30px;margin-bottom: 16px;">小程序跳转码</div>
		<a-tabs :activeKey="tab_key" type="card" @change="callback" :tabBarGutter="10">
			<a-tab-pane key="1" tab="公众号"></a-tab-pane>
			<a-tab-pane key="2" tab="落地页"></a-tab-pane>
		</a-tabs>
	</div>
	</div>	
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;">
		<div v-show="tab_key == '2'" class="screen-box">
			<div class="screen-label">落地页ID</div>
			<a-input v-model="r_link_id" allowClear placeholder="请输入" style="width: 200px;"/>
		</div>
		
		<div v-show="tab_key == '1'" class="screen-box">
			<div class="screen-label">公众号</div>
			<a-select
				show-search
				allowClear
			    style="min-width: 200px"
			    placeholder="请选择公众号"
			    @change="handleChangeA"
				:value="r_gzh_id"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
			    <a-select-option v-for="(item,index) in filterData.gzh_id.list" :key="item.key" :value="item.key">
			      {{item.value}}
			    </a-select-option>
			</a-select>
			
		</div>
		
		<div class="screen-box">
			<div class="screen-label">小程序</div>
			<a-select
				show-search
				allowClear
			    style="min-width: 200px"
			    placeholder="请选择小程序"
			    @change="handleChangeB"
				:value="r_applets_id"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
			    <a-select-option v-for="(item,index) in selectXcx" :key="index" :value="item.id">
			     {{item.name}}
			    </a-select-option>
			</a-select>
			
		</div>
		
		<a-button @click="searchButton('button')" :loading="search_button_loading" type="primary" icon="search" class="screen-box">搜索</a-button>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			
			<div v-if="tab_key == '1'" class="table-th-cell" 
			:style="{'width':rableTitle[0].width + 'px',}">
				公众号名称
			</div>
			<div v-if="tab_key == '2'" class="table-th-cell"
			:style="{'width':rableTitle[1].width + 'px',}">
				落地页ID
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > 1" class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<!-- 公众号名称 -->
			<div v-if="tab_key == '1'" @click="tdCz(2,item)" class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
				<div v-if="item.put_gzh">
					{{item.put_gzh.gzh_name}}
				</div>
			</div>
			<!-- 落地页ID -->
			<div v-if="tab_key == '2'" class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
				{{item.put_link_id}}
			</div>
			<!-- 小程序Id -->
			<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
				
				{{item.applets_id}}
				
			</div>
			<!-- 小程序名称 -->
			<div @click="tdCz(1,item)" class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}"  style="color: #62a8ea;cursor: pointer;">
				<div v-if="item.applets">
					{{item.applets.name}}
				</div>
				
			</div>
			<!-- 跳转地址 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
				{{item.jump_url}}
			</div>
			<!-- 跳转码剩余数量 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
				{{item.scheme_count}}
			</div>
			<!-- 操作 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}" style="display: flex;flex-wrap: wrap;">
				<div @click="tdCz(3,item)" style="margin-right: 10px;cursor: pointer;color: #62a8ea;">测试生成跳转码</div>
				<div @click="tdCz(5,item)" style="color: red;cursor: pointer;">删除</div>
			</div>
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>
	
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		
		<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" />
		
	</div>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { putDataMenu, getLoginLog, logSelectUser, opeGzhXcx, opeGzhSchemeCount, xcxSchemeGenerate, xcxSchemeDel } from '@/request/api'
export default {
	name: 'xcxScheme_',
	components: {
		
	},
	data() {
		return {
			tab_key: "1",
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"公众号名称", width:150, type:"put_gzh", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"落地页ID", width:150, type:"put_link_id", },
				{title:"小程序Id", width:120, type:"applets.id", },
				{title:"小程序名称", width:180, type:"applets.name", },
				{title:"跳转地址", width:220, type:"jump_url", },
				{title:"跳转码剩余数量", width:130, type:"scheme_count", },
				{title:"操作", width:170, type:"cz", },
			],
			tableShowData: [
				{
					put_gzh: {},
					applets: {}
				}
				
			],
			body_width: 1600,
			table_scroll_width: 1000,
			table_null_width: 1000,
			search_button_loading: false,
			
			r_page: 1, // 页数
			r_limit: 50, // 每页多少条
			table_total: 0, // 表格内容总数
			
			r_link_id: "", // 落地页id
			r_gzh_id: undefined, // 公众号id
			r_applets_id: undefined, // 小程序
			
			// 筛选条件部分
			filterData: {
				op_id:{
					list: [{}],
				},
				
				media_id:{
					list: [{}],
				},
				channel_id:{
					list: [{}],
				},
				gzh_id:{
					list: [{}],
				},
				
				
			}, // 筛选条件数组
			
			selectXcx: [], // 小程序列表
		}
	},
	mounted(){
		let that = this
		
		let urls = this.$route.fullPath
		if(urls.indexOf("BDzh") > -1){
			this.tab_key = "1"
		}
		else if(urls.indexOf("BDjh") > -1){
			this.tab_key = "2"
		}
		
		
		console.log(this.$route.query)
		if(this.$route.query){
			// 接收从运营公众号管理页面传过来的参数
			if(this.$route.query.gzh_id){
				// 避免为0的情况，然后请求没有内容返回
				if(Number(this.$route.query.gzh_id)){ 
					this.r_gzh_id = Number(this.$route.query.gzh_id)
				}
			}
			
			// 小程序管理-运营版
			if(this.$route.query.applets_id){
				this.r_applets_id = Number(this.$route.query.applets_id)
			}
		}
		
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		
		putDataMenu().then(res=>{
			console.log("获取搜索条件",res);
			that.filterData = res.data.data.filter
		})
		
		opeGzhXcx().then(res=>{
			console.log("获取小程序",res);
			that.selectXcx = res.data.data.applets
		})
		
		that.searchButton()
	},
	// 销毁生命周期
	beforeDestroy(){
	    
	},
	methods:{
		// 切换tab
		callback(e){
			console.log(e);
			if(e == "1"){ // 公众号
				this.tab_key = "1"
				this.r_page = 1
				this.searchButton()
			}
			else if(e == "2"){ // 落地页
				this.tab_key = "2"
				this.r_page = 1
				this.searchButton()
			}
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		handleChangeA(e){
			console.log(e)
			this.r_gzh_id = e
		},
		handleChangeB(e){
			console.log(e)
			this.r_applets_id = e
		},
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			if(type == "button"){
				that.r_page = 1
			}
			opeGzhSchemeCount({
				page: that.r_page,
				limit: that.r_limit,
				type: that.tab_key, // 1表示公众号，2表示落地页
				gzh_id: that.r_gzh_id, // 公众号
				applets_id: that.r_applets_id, // 小程序
				link_id: that.r_link_id, // 落地页
			}).then(res=>{
				that.search_button_loading = false
				console.log("获取列表",res);
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
			
		},
		// 表格内的操作
		tdCz(e,item){
			let that = this
			console.log("item",item)
			if(e == 1){ // 小程序名称
				
			}
			else if(e == 2){ // 公众号名称
				that.$router.push({ path:'/openGzh',query:{gzh_name: item.put_gzh.gzh_name}})
			}
			else if(e == 3){ // 测试生成跳转码
				// this.$confirm({
				//     title: '确定测试生成跳转码？',
				//     content: `ID：${item.id}`,
				// 	cancelText: "取消",
				// 	okText: "确认",
				//     onOk() {
						that.search_button_loading = true
						xcxSchemeGenerate({
							applets_id: item.applets_id,
							jump_url: item.serialize_url
						}).then(res=>{
							that.search_button_loading = false
							console.log("测试生成跳转码",res);
							if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
								that.$message.success('操作成功');
							}
							else {
								if(res.data.code === 401){ // 未登录
									localStorage.removeItem("access_token");
									that.$router.replace({name: 'login',params: {type:'not_log'}})
								}
								else {
									that.$message.error(`错误：${res.data.msg}`);
								}
							}
						})
						.catch(err=>{
							that.search_button_loading = false
							console.log("err",err);
							that.$message.error('操作失败，请检查请求操作')
						})
				//     },
				//     onCancel() {
				//         console.log('Cancel');
				//     },
				// });
				
			}
			else if(e == 5){ // 删除
				this.$confirm({
					title: '确定要删除该项吗？',
					content: "",
					okText: '确认',
					okType: 'danger',
					cancelText: '取消',
					onOk() {
						that.search_button_loading = true
						xcxSchemeDel({
							applets_id: item.applets_id,
							jump_url: item.serialize_url,
							type: that.tab_key
						}).then(res=>{
							that.search_button_loading = false
							console.log("删除",res);
							that.$message.success('删除成功');
							that.searchButton()
						})
						.catch(err=>{
							that.search_button_loading = false
							console.log("err",err);
							that.$message.error('操作失败，请检查请求操作')
						})
					},
					onCancel() {
					  console.log('Cancel');
					},
				});
				
			}
		}
	},
}
</script>

<style>
</style>